import React, { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { useNavigate } from "react-router-dom";
import { makeStyles } from "@mui/styles";
import { useAuth } from "../../context/AuthContext";
import DashboardMenu from "./DashboardMenu";
import CircularProgress from "@mui/material/CircularProgress";
import Profile from "./HandleProfile/Profile";
import Address from "./HandleAddress/Address";

const useStyles = makeStyles({
	root: { width: 1, display: "flex", paddingBottom: "100px" },
	body: {
		width: "100%",
		borderRadius: "5px",
		border: "1px solid lightgray",
		marginBottom: "30px",
	},
	inputEach: {
		display: "flex",
		alignItems: "center",
		paddingLeft: "10px",
		paddingRight: "10px",
		marginBottom: "20px",
		marginTop: "20px",
	},
	inputs: { width: "70%" },
	label: { width: "160px" },
});

const Dashboard = () => {
	const classes = useStyles();
	let navigate = useNavigate();
	const { currentUser, getFirstname, getLastname, getAddresses } = useAuth();

	const [progress, setProgress] = useState(true);

	const [orders, setOrders] = useState([]);

	useEffect(() => {
		setTimeout(() => {
			setProgress(false);
		}, 500);
	}, []);

	return (
		<Grid className={classes.root} container sx={{ px: 10 }}>
			<Grid
				item
				sm={12}
				md={4}
				sx={{
					// border: "1px solid black",
					px: { md: 3 },
					py: { md: 5, sm: 4 },
				}}
			>
				<DashboardMenu page="userinfo" />
			</Grid>
			<Grid
				sm={12}
				md={8}
				item
				sx={{
					// border: "1px solid black",
					px: { md: 3 },
					py: { md: 5, sm: 2 },
				}}
			>
				<Box className={classes.body}>
					<Box
						sx={{
							width: "100%",
							py: 2,
							display: "flex",
							flexDirection: "column",
							justifyContent: "space-between",
							overflow: "hidden",
						}}
					>
						<Box
							sx={{
								width: "100%",
								display: "flex",
								flexDirection: "column",
								alignItems: "flex-start",
								boxSizing: "border-box",
								px: 4,
							}}
						>
							<Box sx={{ width: 1 }}>
								<Box
									sx={{
										pt: 1,
										fontSize: "23px",
										display: "flex",
										justifyContent: "space-between",
									}}
								>
									<Box>Personal information</Box>
								</Box>
							</Box>

							<Box
								sx={{
									display: "flex",
									justifyContent: progress ? "center" : "flex-start",
									alignItems: "flex-start",
									width: "100%",
									minHeight: "400px",
									boxSizing: "border-box",
									pt: progress ? 5 : 0,
								}}
							>
								{progress ? (
									<CircularProgress />
								) : (
									<Box
										sx={{
											display: "flex",
											flexDirection: "column",
											alignItems: "flex-start",
											pt: 2,
										}}
									>
										<Profile />
										<Address />
									</Box>
								)}
							</Box>
						</Box>
					</Box>
				</Box>
			</Grid>
		</Grid>
	);
};

export default Dashboard;
